import React from 'react';

interface IframeSerializerProps {
  value: { src: string; height?: number | string; width?: number | string };
}

export const IframeBlock = ({ value: { src, height, width } }: IframeSerializerProps) => (
  <iframe
    title={`iframe: ${src}`}
    src={src}
    height={height}
    width={width || '100%'}
    style={{ border: 'none' }}
    allow="fullscreen"
  />
);
